module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/Reports.html -->\n<div class="wrapper wrapper-content">\n    No Reports Yet\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/Reports.html
// module id = 659
// module chunks = 1